import React from 'react';

export default class PolicySetting extends React.Component {
  render() {
    // TODO policy setting
    return <div>policy setting</div>;
  }
}
